import { render, staticRenderFns } from "./QuoteDayInfoBlock.vue?vue&type=template&id=94932fd2"
import script from "./QuoteDayInfoBlock.vue?vue&type=script&lang=js"
export * from "./QuoteDayInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./QuoteDayInfoBlock.vue?vue&type=style&index=0&id=94932fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports